"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "value"
};
const CardTitle_vue_1 = __importDefault(require("./CardTitle.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'CardBlock',
    props: {
        title: {
            type: String,
            required: true,
        },
        // eslint-disable-next-line vue/require-default-prop
        value: {
            type: [String, Array],
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(CardTitle_vue_1.default, {
                    title: `${__props.title}`
                }, null, 8, ["title"]),
                (!Array.isArray(__props.value))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, (0, vue_2.toDisplayString)(__props.value), 1))
                    : ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, (0, vue_2.renderList)(__props.value, (item, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", { key: index }, (0, vue_2.toDisplayString)(item), 1));
                    }), 128))
            ], 64));
        };
    }
});
